import { handleActions } from 'redux-actions'
import {
  getIceInfo,
  notifyIceServers,
  resolveAgentAddress,
  notifyAgentAddress,
  notifyAgentDescription,
  descriptionsInSync,
  sendOffer,
  sendIceCandidate,
  notifyUserDetails,
  notifyAgentDetails
} from '../actions/signaling'
import { restartRTC } from './../actions/app'

const initialState = {
  peerToPeerConnectionState: '',
  stunList: null,
  turnList: null,
  agentAddress: '',
  agentDescription: '', // (agent sdp) via notifyAgentDescription
  permissions: [], // via notifyAgentDescription
  agentDetails: {}, // via notifyAgentDetails
}

export const signalingReducer = handleActions({
  [getIceInfo] (prevState) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'GET_ICE_SERVERS'
    }
  },
  [notifyIceServers] (prevState, action) {
    return {
      ...prevState,
      ...action.payload
    }
  },
  [resolveAgentAddress] (prevState) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'RESOLVE_AGENT_ADDRESS'
    }
  },
  [notifyAgentAddress] (prevState, action) {
    return {
      ...prevState,
      ...action.payload
    }
  },
  [notifyUserDetails] (prevState, action) {
    return {
      ...prevState,
      ...action.payload
    }
  },
  [notifyAgentDescription] (prevState, action) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'ANSWER_RECEIVED',
      ...action.payload
    }
  },
  [sendIceCandidate] (prevState) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'SEND_ICE_CANDIDATE',
    }
  },
  [sendOffer] (prevState, action) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'OFFER_SENT',
      clientDescription: action.payload
    }
  },
  [descriptionsInSync] (prevState) {
    return {
      ...prevState,
      peerToPeerConnectionState: 'DESCRIPTIONS_SYNCHRONIZED',
    }
  },
  [notifyAgentDetails] (prevState, action) {
    return {
      ...prevState,
      ...action.payload
    }
  },
  [restartRTC] (prevState) {
    return {
      ...prevState,
      ...initialState
    }
  }
}, initialState)
